import { call, put, takeLatest } from 'redux-saga/effects'

import {
  postRole,
  putRole,
  deleteRole,
  postFarmRole,
  putFarmRole,
  deleteFarmRole,
  toggleFarmRoleModules
} from '@galo-monitor/services/apis/galoMonitorApi/resources/role'

import { RoleActions, RoleTypes } from './duckRole'

function* saveRole({ role, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(role.id ? putRole : postRole , role)
    yield call(onSuccess)
  } catch (err) {
    yield put(RoleActions.roleError(err.message))
    yield call(onError, err)
  }
}

function* removeRole({ role, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteRole, role)
    yield call(onSuccess)
  } catch (err) {
    yield put(RoleActions.roleError(err.message))
    yield call(onError, err)
  }
}

function* saveFarmRole({ role, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(role.id ? putFarmRole : postFarmRole , role)
    yield call(onSuccess)
  } catch (err) {
    yield put(RoleActions.roleError(err.message))
    yield call(onError, err)
  }
}

function* removeFarmRole({ role, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(deleteFarmRole, role)
    yield call(onSuccess)
  } catch (err) {
    yield put(RoleActions.roleError(err.message))
    yield call(onError, err)
  }
}

function* saveFarmRoleModules({ role, onSuccess = () => {}, onError = () => {} }) {
  try {
    yield call(toggleFarmRoleModules, role)
    yield call(onSuccess)
  } catch (err) {
    yield put(RoleActions.roleError(err.message))
    yield call(onError, err)
  }
}

export default [
  takeLatest(RoleTypes.SAVE_ROLE, saveRole),
  takeLatest(RoleTypes.REMOVE_ROLE, removeRole),
  takeLatest(RoleTypes.SAVE_FARM_ROLE, saveFarmRole),
  takeLatest(RoleTypes.REMOVE_FARM_ROLE, removeFarmRole),
  takeLatest(RoleTypes.SAVE_FARM_ROLE_MODULES, saveFarmRoleModules)
]
